import React from 'react';
import ChipInput from 'material-ui-chip-input'
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";

const useStyles = makeStyles((theme) => ({
  margin: {
    marginBottom: theme.spacing(4),
  },
  label: {
    display: 'block',
    position: 'initial',
    transform: 'scale(1)',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  hint: {
    display: 'block',
    marginBottom: theme.spacing(1),
    fontSize: 13,
  },
  chipRoot: {
    '& .MuiInputBase-formControl': {
      paddingTop: 10,
      marginTop: theme.spacing(1),
    },
    '& .MuiOutlinedInput-root:hover input': {
      backgroundColor: 'transparent'
    },
    '& .MuiInputBase-root': {
      background: theme.palette.background.default,
      '& .MuiChip-root': {
        background:'hsl(0,0%,90%)',
        color: theme.palette.text.primary
      }
    },
    '& .MuiChip-deleteIcon': {
      width: 14,
      color: theme.palette.text.primary
    }
  }
}));

export default ({ value = [], onChange, label, hint, hasError, helpText, ...other }) => {
  const classes = useStyles();

  const handleAddChip = (chip) =>{
    value.push(chip);
    onChange(value);
  };

  const handleDeleteChip = (chip, idx) => {
    onChange(value.filter(i => i !== chip));
  };

  return (
    <div className={classes.margin}>
      {label && (
        <InputLabel disableAnimation shrink className={classes.label}>
          {label}
        </InputLabel>
      )}
      { hint && (
        <Typography className={classes.hint} color="textSecondary" variant="caption">{hint}</Typography>
      )}
      <ChipInput
        className={classes.chipRoot}
        value={value}
        onAdd={handleAddChip}
        onDelete={handleDeleteChip}
        FormHelperTextProps={{ error: hasError }}
        helperText={helpText}
        InputProps={{
          disableUnderline: true,
        }}
        variant="filled"
        {...other}
      />
    </div>
  )
}
